import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import type { LeadRegisterRequest, LeadRegisterResponse } from '../models';

/**
 * LeadApi — public landing-page lead capture.
 *
 * Registers a partner lead from the "Join Us" form. The endpoint is public
 * but the backend gate still requires a token value, so this call sends the
 * static lead API key explicitly (not the user JWT). Setting the header here
 * means the authInterceptor leaves it untouched (it only attaches a token when
 * no Authorization header is already present), so the form works regardless of
 * whether a merchant is logged in.
 */
@Injectable({
  providedIn: 'root',
})
export class LeadApi {
  private readonly http = inject(HttpClient);

  /**
   * Register a new partner lead.
   * Endpoint: POST /api/lead/lead_register
   *
   * @param payload - Populated lead form values (empty fields already pruned)
   * @returns Observable of the lead registration response
   */
  registerLead(payload: LeadRegisterRequest): Observable<LeadRegisterResponse> {
    return this.http
      .post<LeadRegisterResponse>(`${environment.apiUrl}/api/lead/lead_register`, payload, {
        headers: { Authorization: `Bearer ${environment.leadApiKey}` },
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('❌ Failed to register lead:', error);
          return throwError(() => error);
        }),
      );
  }
}
